document.addEventListener('DOMContentLoaded', function () {
    const swiper = document.querySelector('.community-slider-section__swiper');

    // Initialize Swiper for .community-slider-section__swiper
    const swiperInstance = new Swiper(swiper, {
        freeMode: true,
        loop: false,
        spaceBetween: 12,
        slidesPerView: 1.45,
        grabCursor: true,
        mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
        },
        watchOverflow: true,
        breakpoints: {
            451: { slidesPerView: 1.4, spaceBetween: 17 },
            501: { slidesPerView: 1.6, spaceBetween: 17 },
            601: { slidesPerView: 2.15, spaceBetween: 17 },
            701: { slidesPerView: 2.5, spaceBetween: 17 },
            801: { slidesPerView: 2.75, spaceBetween: 17 },
            1001: { slidesPerView: 3.5, spaceBetween: 17 },
            1301: { slidesPerView: 4, spaceBetween: 17 },
        },
    });
});
